module.exports = __webpack_public_path__ + "static/media/sass-logo.084f0cf8.png";